
<div :class="classes(n())">
  <!--
    triggerRef 是触发元素的包裹容器，display:inline-flex 使其尺寸与 slot 元素一致。
    position:relative 作为 arrow 和 content 的定位基准。
    currentPosition 类用于 CSS 控制箭头方向（border-color）。
  -->
  <div
    ref="triggerRef"
    :class="[classes(n('trigger')), innerVisible ? n(`--${currentPosition}`) : '']"
  >
    <slot />

    <template v-if="innerVisible">
      <!-- 箭头：通过 CSS border-color 控制方向，JS 控制 borderWidth 及位置 -->
      <div
        :class="[classes(n('arrow')), animClass]"
        :style="arrowStyle"
      />

      <!-- 气泡内容 -->
      <div
        ref="tooltipRef"
        :class="[
          classes(n('content')),
          closeIcon ? classes(n('content--close')) : '',
          animClass,
        ]"
        :style="contentStyle"
        role="tooltip"
      >
        <div :class="classes(n('content-inner'))">
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div :class="classes(n('text'))" v-html="content" />
          <div
            v-if="closeIcon"
            :class="classes(n('close-hit'))"
            role="button"
            aria-label="Close tooltip"
            @click="handleClose"
          >
            <CloseIcon
              :class="classes(n('close-icon'))"
              :width="32"
              :height="32"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</div>
